var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getListToRender } from '../getListToRender';
import { moveFocusOutside } from '../moveFocusOutside';
export var createReducer = function (_a) {
    var searchAttributes = _a.searchAttributes, dropdownList = _a.dropdownList, displayAttribute = _a.displayAttribute, noMatchDropdownList = _a.noMatchDropdownList, maxRenderedDropdownElements = _a.maxRenderedDropdownElements, searchMatcher = _a.searchMatcher, onChange = _a.onChange;
    return function (state, action) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        switch (action.type) {
            case 'InputKeyDownEscape': {
                return __assign(__assign({}, state), { noMatch: false, isExpanded: false, highlightedIndex: -1, inputValue: state.selectedItem
                        ? state.selectedItem[displayAttribute]
                        : '' });
            }
            case 'InputClick': {
                var _m = getListToRender({
                    inputValue: state.inputValue,
                    searchAttributes: searchAttributes,
                    maxRenderedDropdownElements: maxRenderedDropdownElements,
                    dropdownList: dropdownList,
                    noMatchDropdownList: noMatchDropdownList,
                    searchMatcher: searchMatcher,
                    showAllItemsInDropdown: true,
                }), noMatch = _m.noMatch, listToRender = _m.listToRender;
                return __assign(__assign({}, state), { isExpanded: true, listToRender: listToRender, noMatch: noMatch });
            }
            case 'InputChange': {
                var _o = getListToRender({
                    inputValue: (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.inputValue) !== null && _b !== void 0 ? _b : '',
                    searchAttributes: searchAttributes,
                    maxRenderedDropdownElements: maxRenderedDropdownElements,
                    dropdownList: dropdownList,
                    noMatchDropdownList: noMatchDropdownList,
                    searchMatcher: searchMatcher,
                    showAllItemsInDropdown: false,
                }), noMatch = _o.noMatch, listToRender = _o.listToRender;
                return __assign(__assign({}, state), { isExpanded: true, inputValue: (_d = (_c = action.payload) === null || _c === void 0 ? void 0 : _c.inputValue) !== null && _d !== void 0 ? _d : '', listToRender: listToRender, highlightedIndex: ((_f = (_e = action.payload) === null || _e === void 0 ? void 0 : _e.inputValue) === null || _f === void 0 ? void 0 : _f.trim()) === '' ||
                        listToRender.length === 0
                        ? -1
                        : 0, noMatch: noMatch });
            }
            case 'ToggleButtonPressed': {
                if (state.isExpanded) {
                    var _p = moveFocusOutside({
                        state: state,
                        searchAttributes: searchAttributes,
                        maxRenderedDropdownElements: maxRenderedDropdownElements,
                        dropdownList: dropdownList,
                        noMatchDropdownList: noMatchDropdownList,
                        searchMatcher: searchMatcher,
                        displayAttribute: displayAttribute,
                        onChange: onChange,
                    }), listToRender = _p.listToRender, inputValue = _p.inputValue, selectedItem = _p.selectedItem;
                    return __assign(__assign({}, state), { isExpanded: false, highlightedIndex: -1, inputValue: inputValue, selectedItem: selectedItem, listToRender: listToRender });
                }
                return __assign(__assign({}, state), { isExpanded: !state.isExpanded });
            }
            case 'ItemSelectedProgrammatically':
            case 'ItemOnClick':
            case 'InputKeyDownEnter': {
                return __assign(__assign({}, state), { isExpanded: false, highlightedIndex: -1, selectedItem: (_g = action.payload) === null || _g === void 0 ? void 0 : _g.selectedItem, inputValue: ((_j = (_h = action.payload) === null || _h === void 0 ? void 0 : _h.selectedItem) === null || _j === void 0 ? void 0 : _j[displayAttribute]) || '' });
            }
            case 'InputKeyDownArrowDown':
            case 'InputKeyDownArrowUp': {
                return __assign(__assign({}, state), { isExpanded: true, highlightedIndex: (_l = (_k = action.payload) === null || _k === void 0 ? void 0 : _k.highlightedIndex) !== null && _l !== void 0 ? _l : -1 });
            }
            case 'FocusMovedOutSide': {
                var _q = moveFocusOutside({
                    state: state,
                    searchAttributes: searchAttributes,
                    maxRenderedDropdownElements: maxRenderedDropdownElements,
                    dropdownList: dropdownList,
                    noMatchDropdownList: noMatchDropdownList,
                    searchMatcher: searchMatcher,
                    displayAttribute: displayAttribute,
                    onChange: onChange,
                }), listToRender = _q.listToRender, inputValue = _q.inputValue, selectedItem = _q.selectedItem;
                return __assign(__assign({}, state), { isExpanded: false, highlightedIndex: -1, inputValue: inputValue, selectedItem: selectedItem, listToRender: listToRender });
            }
            case 'DropdownListPropUpdated': {
                return __assign(__assign({}, state), getListToRender({
                    inputValue: state.inputValue,
                    searchAttributes: searchAttributes,
                    maxRenderedDropdownElements: maxRenderedDropdownElements,
                    dropdownList: dropdownList,
                    noMatchDropdownList: noMatchDropdownList,
                    searchMatcher: searchMatcher,
                    showAllItemsInDropdown: !!state.selectedItem,
                }));
            }
            default:
                return state;
        }
    };
};
